import React, { useContext, useEffect, useState, useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import { SHOPIFY_API_KEY, SHOPIFY_EMBEDDED_FORCE_REDIRECT } from 'aws-exports';
import { Provider } from '@shopify/app-bridge-react';
import createApp from '@shopify/app-bridge';
import { Redirect, History, Toast } from '@shopify/app-bridge/actions';
// import { useRoutePropagation } from "@shopify/react-shopify-app-route-propagator";
import useReactRouter from 'use-react-router';
import NotifyContext from 'context/NotifyContext';
import ShopContext from 'context/ShopContext';
import { ErrorScreen } from 'screens';
import { EmbeddedProvider } from 'context/EmbeddedContext';
import UserContext from 'context/UserContext';
import { ENGINE_WARNING_ICON } from 'lib/globals';
import ChargeApproval from './chargeApproval';
import WelcomeModal from './welcomeModal';
import { setupModalAutoSizing } from '@shopify/app-bridge-utils';
import getPlans, { getBasePrice } from 'lib/getPlans';
import { API } from 'aws-amplify';
import classNames from 'lib/classNames';

const Embedded = ({ children, location, newPlanRedirect }) => {
    const { history } = useReactRouter();
    const user = useContext(UserContext);
    const shopContext = useContext(ShopContext);
    const {
        state: {
            settings,
            settingsSaved,
            chargeConfirmationUrl,
            redirectToChargeApproval,
            id,
            installedAt,
            invitation
            // show_recharge_alert
        },
        setItem
    } = shopContext;
    const { createNotification, deleteNotification } = useContext(NotifyContext);
    const plans = getPlans(new Date(installedAt).getTime());
    const hasDiscount =
        invitation && invitation?.type === 'discount_percentage' && invitation?.value;
    const discount = hasDiscount ? invitation?.value / 100 : 0;
    const applyDiscount = (value) => Number((value - value * discount).toFixed(2));
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    const config = {
        apiKey: SHOPIFY_API_KEY,
        shopOrigin: user.attributes.website,
        forceRedirect: SHOPIFY_EMBEDDED_FORCE_REDIRECT,
        host: params.get('host') || btoa(user.attributes.website)
    };
    const getPlan = async () => {
        const planResponse = await API.get('API_GATEWAY_NEW', '/shop/get_plan');
        const balance_used = Number(planResponse.balance_used);
        const currentPlan =
            balance_used === 0
                ? 0
                : plans.findIndex(
                      ({ real_price }) =>
                          applyDiscount(real_price).toString() ===
                          (balance_used + applyDiscount(getBasePrice())).toFixed(2)
                  );
        if (window.$crisp) {
            window.$crisp.push(['set', 'session:data', ['Plan', plans[currentPlan]?.description]]);
        }
    };
    const app = createApp(config);
    setupModalAutoSizing(app);
    const AppBridgeHistory = History.create(app);
    const AppBridgeRedirect = Redirect.create(app);
    const AppBridgeToast = (toastOptions) => {
        const toast = Toast.create(app, toastOptions);
        return {
            open() {
                toast.dispatch(Toast.Action.SHOW);
            }
        };
    };
    useEffect(() => {
        getPlan();
    }, []);
    // useRoutePropagation(app, location);
    useEffect(() => {
        if (window.$crisp) {
            window.$crisp.push(['set', 'session:data', ['store', id]]);
            window.$crisp.push(['set', 'session:data', ['App', 'Monster UPSELLS']]);
        }
    }, [settings]);
    useEffect(() => {
        if (params.get('source') === 'charge-accepted') {
            if (typeof window.fbq === 'function') {
                window.fbq('track', 'TrialStarted');
            }
            AppBridgeRedirect.dispatch(Redirect.Action.APP, '');
        }
    }, [params]);
    useEffect(() => {
        async function requestV2Scopes() {
            const response = await window.shopify.scopes.request([
                'read_inventory',
                'read_locales',
                'read_markets',
                'read_products',
                'unauthenticated_read_product_listings',
                'write_discounts',
                'write_draft_orders',
                'write_orders',
                'write_price_rules',
                'write_products',
                'write_themes'
            ]);
            console.log('scopes requested', response);
        }
        requestV2Scopes();
    }, []);
    // src={ `${window.location.origin}/${getPlansModal(new Date(installedAt).getTime())}?chargeConfirmationUrl=${chargeConfirmationUrl}`}
    return (
        <>
            <EmbeddedProvider value={{ app, AppBridgeRedirect, AppBridgeHistory, AppBridgeToast }}>
                <Provider config={config}>
                    {!!(
                        redirectToChargeApproval && window.location.pathname !== '/affiliation'
                    ) && <ChargeApproval />}
                    {/* {!redirectToChargeApproval && <WelcomeModal />} */}
                    <ErrorScreen>{children}</ErrorScreen>
                </Provider>
            </EmbeddedProvider>
        </>
    );
};

export default withRouter(Embedded);
